import { FiSend } from "react-icons/fi"
import { IoWalletOutline } from "react-icons/io5"
import { TfiWorld } from "react-icons/tfi"
import ContainerLayout from "./containerlayout"
import { PropTypes } from 'prop-types';
import { useState } from "react";
import ModelButton from "../modelBtn/modelButton";
import PaymentPopUp from "./paymentPopUp";





const Card = ({ title, icon, bg,link, children }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);
    return (
        children ?
            <>
                <div
                    onClick={() => (modalOpen ? closed() : open())}
                    className={`  w-full  flex flex-col items-center gap-8 py-8 cursor-pointer`}>
                    <div className="flex items-center justify-start gap-2">
                        <div className={`p-4 rounded-full ${bg} text-white`}>
                            {icon}
                        </div>
                        <h2 className="uppercase font-bold text-lg text-center w-auto ">{title}</h2>
                    </div>
                </div>
                <ModelButton modalOpen={modalOpen} close={closed}>
                    {children}
                </ModelButton>
            </>
            :
            <a href={link} target="_blank" rel="noreferrer" download={link} className={`  w-full  flex flex-col items-center gap-8 py-8`}>
                <div className="flex items-center justify-start gap-2">
                    <div className={`p-4 rounded-full ${bg} text-white`}>
                        {icon}
                    </div>
                    <h2 className="uppercase font-bold text-lg text-center w-auto ">{title}</h2>
                </div>
            </a>
    )
}
Card.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.object,
    bg: PropTypes.string,
    children: PropTypes.node

}


const ApplyOptions = ({ admission }) => {


    const rowButton1 = admission?.rowButton1?.items?.map(item => {
        item = item?.content?.properties

        return {
            label: item?.label,
            url: item?.link
        }
    }
    )[0]
    const rowButton2 = admission?.rowButton2?.items?.map(item => {
        item = item?.content?.properties

        return {
            label: item?.label,
            url: item?.link
        }
    }
    )[0]
    const rowButton3 = admission?.rowButton3?.items?.map(item => {
        item = item?.content?.properties

        return {
            label: item?.label,
            url: item?.pagePath?.route?.path
        }
    }
    )[0]



    const options = [
        {
            icon: <FiSend size={25} />,
            bg: "bg-blue-600",
            title: rowButton1?.label,
            link: rowButton1?.url
        },
        {
            icon: <TfiWorld size={25} />,
            bg: "bg-red-600",
            title: rowButton2?.label,
            link: rowButton2?.url
        },
        {
            icon: <IoWalletOutline size={25} />,
            bg: "bg-orange-600",
            title: rowButton3?.label,
            children: <PaymentPopUp url={rowButton3?.url} />
        },

    ]
    return (

        <ContainerLayout color="bg-[#f7f5ed] text-slate-900">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-10  w-full ">
                {
                    options.map((option, index) => (
                        <Card {...option} key={index} />
                    ))
                }
            </div>
        </ContainerLayout>
    )
}
ApplyOptions.propTypes = {
    admission: PropTypes.any
}
export default ApplyOptions